import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import React from 'react';
import { withBasePath } from 'src/common/pathConvert';
import styles from './AppTicketFilling.module.scss';

type Props = {
    content?: any;
};

export default function AppTicketFilling({ content }: Props) {
    const [t] = useTranslation();

    let iconIndex = 0;
    const icons = ['a.gif', 'b.gif', 'c.gif', 'd.gif', 'e.gif', 'f.gif', 'g.gif', 'h.gif', 'i.png'];
    const ticketLegends = content?.ticketLegends?.targetItems?.map((item: any, index: number) => {
        let iconPath = '';
        if (item?.legendIconEnabled?.value === '1') {
            iconPath = item?.legendIcon?.src;
        } else {
            if (iconIndex < icons.length) {
                iconPath = withBasePath(`/images/ticket-legends/icon_${icons[iconIndex++]}`);
            }
        }

        return (
            <div className='flex py-1' key={index}>
                <img width={15} height={15} src={iconPath} alt='' />
                <span className='pl-3'>{item?.legendName?.value}</span>
            </div>
        );
    });
    return (
        <div className={styles['ticket-filling']}>
            <div className='marksix-sub-title'>
                <a id={content?.name}></a>
                {content?.ticketTypeName?.value}
            </div>
            <div className='flex flex-wrap'>
                <div className='flex flex-wrap  w-full py-3 pl-5 sm:pl-20 md-:pl-8 md:pl-8 lg:pl-10 xl:pl-20 2xl:pl-40'>
                    <div className='flex flex-col items-start w-full md-:w-1/2'>
                        <div className='flex flex-col items-center'>
                            <span className='underline'>{t('TicketFilling')}</span>
                            <img
                                className='max-w-full'
                                src={content?.ticketFillingImage?.src}
                                alt=''
                            ></img>
                        </div>
                        <div className='text-xs max-w-full items-start w-full md-:hidden '>
                            <div
                                className={styles['filling-detail']}
                                dangerouslySetInnerHTML={{
                                    __html: content?.ticketTypeContent?.value,
                                }}
                            ></div>
                        </div>
                    </div>

                    <div className='flex flex-col items-start w-full mt-5 md-:mt-0 md-:w-1/2'>
                        <div className='flex flex-col items-center'>
                            <span className='underline'>{t('TicketValidation')}</span>
                            <img
                                className='max-w-full pt-2'
                                src={content?.ticketValidationImage?.src}
                                alt=''
                            ></img>
                        </div>
                    </div>
                    <div className='text-xs max-w-full items-start w-1/2 hidden  md-:flex '>
                        <div
                            className={styles['filling-detail']}
                            dangerouslySetInnerHTML={{ __html: content?.ticketTypeContent?.value }}
                        ></div>
                    </div>

                    <div className='flex flex-col items-start text-xs w-full md-:w-1/2  md-:flex '>
                        <div>{ticketLegends}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
